import { render, staticRenderFns } from "./ReportNeedsAnalysis.vue?vue&type=template&id=b10f52a6&scoped=true&"
import script from "./ReportNeedsAnalysis.vue?vue&type=script&lang=js&"
export * from "./ReportNeedsAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./ReportNeedsAnalysis.vue?vue&type=style&index=0&id=b10f52a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b10f52a6",
  null
  
)

export default component.exports